module.exports = __webpack_public_path__ + "media/dt.75c06af1.wav";